import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {setI18n} from './api/i18n'
import {getCodeValueByLocale} from "@/utils";
import simpleVueValidator from 'simple-vue3-validator'

setI18n()
	.then((i18n) => {
		const app = createApp(App);

		app.config.globalProperties.$localeCode = getCodeValueByLocale;

		app.use(router);
		app.use(store);
		app.use(simpleVueValidator);
		app.use(i18n);
		app.mount('#app');

// 아래 코드 주석 해제 시 warn 로그 출력 안됨.
		app.config.warnHandler = () => null;
	})
